import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { EditTeachingOrderGridCard } from './EditTeachingOrderGridCard';

export const EditTeachingOrderSortableItem: React.FC<any> = (props) => {
  const sortable = useSortable({ id: props.item });
  const { attributes, listeners, setNodeRef, transform, transition } = sortable;

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    visibility: props.visible ? 'visible' : 'hidden',
  };

  return (
    <EditTeachingOrderGridCard
      ref={setNodeRef}
      style={style}
      {...props}
      {...attributes}
      {...listeners}
    />
  );
};
